import React, { useEffect, useState } from "react";
import "./deliverydetails.css";
import { Controller, useForm } from "react-hook-form";
import AddtoCartBtn from "../AddtoCartbtn/AddtoCartBtn";
import { batch, useDispatch, useSelector } from "react-redux";
import { X } from "phosphor-react";
import { useNavigate } from "react-router-dom";
import { setToastMessage } from "../../appState/slices/util/utilSlice";
import axios from "axios";
import { API } from "../../constants/apiPath";
import DeliveryForm from "./DeliveryForm";
import CouponSelector from "./CouponSelector";
import { RESTRICTED_PINCODES } from "../../constants/restrictedpincodes";
import { ALLOWED_PINCODES } from "../../constants/allowedpincodes";


const getAuthHeaders = () => {
  const token = localStorage.getItem("accessToken");

  return token
    ? { Authorization: `Bearer ${token}` }
    : {};
};


const DeliveryDetails = () => {
  const cart = useSelector((state) => state.cart.checkoutcart);
  // const paymentOrderInfo = useSelector((state) => state.order.paymentOrderInfo);
  const user = useSelector(state => state.auth.user);
  const username = user?.name;
  const homeaddress = user?.addresses.home;
  const workaddress = user?.addresses.work;
  const [addressdetails, setaddressdetails] = useState(homeaddress);
  const [showapplycoupon, setShowapplycoupon] = useState(false);
  const [showpaymentopts, setshowpaymentopts] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState('home');
  const [checkoutAddressDetails, setcheckoutAddressDetails] = useState(homeaddress);
  const [formsubmitdata, setFormSubmitData] = useState("");
  const [couponvalue, setCouponValue] = useState(0);
  const [couponname, setCouponName] = useState("");
  const [name, setName] = useState(username ? username : "");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    control,
    formState: { errors },
  } = useForm();
  const selectedcheckoutAddressDetails = (value) => {
    setcheckoutAddressDetails(value);
  }
  const selectedcoupon = (value) => {
    setShowapplycoupon(!value);
  };
  const removecoupon = () => {
    setCouponName("");
    setCouponValue(0);
  }
  const selectedcouponname = (value) => {
    setCouponName(value);
  }
  const setselectedCouponValue = (value) => {
    setCouponValue(value);
  }
  const selectcoupon = () => {
    setShowapplycoupon(!showapplycoupon);
  };
  const handleChange = (e) => {
    const value = e.target.value;
    if (value === 'home') {
      setaddressdetails(homeaddress);
      setcheckoutAddressDetails(homeaddress);
    }
    else if (value === 'work') {
      setaddressdetails(workaddress);
      setcheckoutAddressDetails(workaddress);
    }
    setSelectedAddress(value);
  };
  const handleChangeName = (e) => {
    setName(e.target.value);
  }


  const initPayment = (data, key, dbOrderId) => {

    const options = {

      key: key,

      amount: data.amount,

      currency: data.currency,

      order_id: data.id,

      name: "Purecarats",

      handler: async (response) => {

        try {

          const verifyRes = await axios.post(
            `${process.env.REACT_APP_API_URL}${API.ORDER.VERIFY}`,
            response,
            {
              withCredentials: true,
              headers: getAuthHeaders(),
            }
          );

          if (verifyRes.data.success) {

            dispatch(
              setToastMessage({
                type: "success",
                message: "Payment successful",
                show: true,
              })
            );

            setTimeout(() => navigate("/"), 300);

          } else {

            throw new Error("Verification failed");

          }

        }
        catch (error) {

          console.error(error);

          dispatch(
            setToastMessage({
              type: "error",
              message: "Payment verification failed",
              show: true,
            })
          );

        }

      },

      modal: {

        ondismiss: async function () {

          await axios.post(
            `${process.env.REACT_APP_API_URL}/api/order/payment-failed`,
            {
              razorpayOrderId: data.id,
              reason: "User closed payment popup"
            },
            {
              withCredentials: true,
              headers: getAuthHeaders(),
            }
          );

        }

      }

    };


    const rzp = new window.Razorpay(options);


    rzp.on("payment.failed", async function (response) {

      dispatch(
        setToastMessage({
          type: "error",
          message: "Payment failed",
          show: true,
        })
      );

      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/order/payment-failed`,
        {
          razorpayOrderId: response.error.metadata.order_id,
          reason: response.error.description
        },
        {
          withCredentials: true,
          headers: getAuthHeaders(),

        }
      );

    });


    rzp.open();

  };

  const confirmOrder = async ({
    address1,
    address2,
    addressType,
    city,
    online,
    postalCode,
    state,
  }) => {
    try {
      const payload = {
        addressDetail: {
          addressLine1: checkoutAddressDetails.addressLine1,
          addressLine2: checkoutAddressDetails.addressLine2,
          addressType,
          city: checkoutAddressDetails.city,
          postalCode: checkoutAddressDetails.postalCode,
          state: checkoutAddressDetails.state,
        },
        deliveryCharges: 0,
        paymentMode: online,
        name: name
      };
      const { data } = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_API_URL}${API.ORDER.POST}`,
        withCredentials: true,
        headers: getAuthHeaders(),
        data: payload,
      });
      if (data.paymentMode === "online") {
        await initPayment(data.order, data.key);
      } else {
        dispatch(
          setToastMessage({
            type: "success",
            message: "Order created successfully",
            show: true,
          })
        );
        navigate("/");
      }
    } catch (error) {
      console.error(error.message);
    }
  };
  const onSubmit = (data) => {
    setFormSubmitData(data);
    setshowpaymentopts(true);
  };



  const handleProceedClick = (e) => {
    const pincode = String(checkoutAddressDetails?.postalCode);

    if (!ALLOWED_PINCODES[pincode]) {
      e.preventDefault();

      dispatch(
        setToastMessage({
          type: "error",
          message: "Currently delivery is not available at this location. Please Contact Us we will try another way to deliver it to you.",
          show: true,
        })
      );
    }
  };

  return (
    <div className="checkout-full-area">
      {/* {showapplycoupon || showpaymentopts ? null : (
          <div className="applycouponcontainer">
            <div className="applycoupon t5 font-semibold">{couponvalue !== 0 ? couponname : "Apply coupon" }</div>
            {couponvalue !== 0 ?
            <div className="couponselectbtn t5" onClick={removecoupon}>
            Remove
          </div>
          :
          <div className="couponselectbtn t5" onClick={selectcoupon}>
              select
            </div> }
            
          </div>
        )} */}

      <div className="totaldetail">
        <div className="ordervalue t6 font-semibold">
          <div>Order value</div>
          <div>{cart.totalamount}</div>
        </div>
        <div className="ordervalue t6 font-semibold">
          <div>Tax Amount</div>
          <div>{cart.taxamount}</div>
        </div>
        {/* <div className="ordervalue t6 font-semibold">
            <div>coupon discount</div>
            <div>{couponvalue}</div>
          </div> */}
        <div className="totalprice t4 font-bold">
          <div>Total</div>
          <div>{cart.finalamount}</div>
        </div>
      </div>
      <br />
      <form
        className="deliveryform"
        onSubmit={
          showpaymentopts ? handleSubmit(confirmOrder) : handleSubmit(onSubmit)
        }
      >
        {showpaymentopts ? (
          <div className="select-paymentopts-container">
            <div className="t3 font-semibold">Select Payment</div>
            <Controller
              name="online"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <div className="onlinecodradio">
                  <label htmlFor="online">
                    <input {...field} type="radio" value="online" id="online" />

                    &nbsp;online payment
                  </label>
                  <label htmlFor="cod">
                    <input {...field} type="radio" value="cod" id="cod" disabled />
                    &nbsp;Cash on delivery (Not available currently)
                  </label>
                </div>
              )}
            />
          </div>
        ) : showapplycoupon ? (
          <CouponSelector selectedcouponname={selectedcouponname} setselectedCouponValue={setselectedCouponValue} selectedcoupon={selectedcoupon} showapplycoupon={showapplycoupon} />
        ) : (
          <div className="deliverydetailscontainer t6">
            <div className="t3 font-semibold">delivery address</div>
            <div className="selectaddress">
              <div className="radio-container">
                <input
                  id="home"
                  value="home"
                  type="radio"
                  checked={selectedAddress === 'home'}
                  onChange={handleChange}
                />
                <label htmlFor="home">Home</label>
              </div>
              <div className="radio-container">
                <input
                  id="work"
                  value="work"
                  checked={selectedAddress === 'work'}
                  type="radio"
                  onChange={handleChange}
                />
                <label htmlFor="work">Work</label>
              </div>
            </div>
            <div className="delivery-input-container">
              <input type="text" placeholder="name" onChange={handleChangeName} value={name} />
            </div>
            <DeliveryForm selectedcheckoutAddressDetails={selectedcheckoutAddressDetails} addressdetails={checkoutAddressDetails} />
          </div>
        )}


        {showpaymentopts ? (
          <AddtoCartBtn
            className="submit-btn"
            type="submit"
            name="confirm order"
          />
        ) :
          (
            <AddtoCartBtn
              className="submit-btn"
              type="submit"
              name="proceed to pay"
              onClick={handleProceedClick}

            />
          )}
      </form>
    </div>
  );
};

export default DeliveryDetails;
